export default __webpack_public_path__ + "static/media/DB_6.b20f86a0.png";